<template>
  <div class="question-item">
    <div class="tag">{{ questionType }}</div>
    <div class="q-title">{{ index + 1 }}、{{ question.question }}</div>
    <template>
      <div
        v-for="(item, index) in answers"
        @click="selectAnswer(index)"
        class="anwser-item"
        :key="index"
        :class="{
          selected: btnStatus.type == 0 && selectedAnswer.indexOf(index) > -1,
          right:
            btnStatus.type == 1 &&
            rightAnswer.indexOf(index) > -1 &&
            selectedAnswer.indexOf(index) > -1,
          rest:
            btnStatus.type == 1 &&
            selectedAnswer.indexOf(index) < 0 &&
            rightAnswer.indexOf(index) > -1 &&
            question.type != 4,
          error:
            btnStatus.type == 1 &&
            selectedAnswer.indexOf(index) > -1 &&
            rightAnswer.indexOf(index) < 0,
        }"
      >
        {{ ["A", "B", "C", "D"][index] }} &nbsp; &nbsp; &nbsp; {{ item }}
      </div>
    </template>
    <div class="ctrls" v-if="selectedAnswer !== undefined">
      <button class="btn" @click="onBtnClick">
        {{
          btnStatus.type == 1 && maxLength === index + 1
            ? "完成答题"
            : btnStatus.text
        }}
      </button>
    </div>
  </div>
</template>

<script>
const BTN_STATUS = [
  {
    type: 0,
    text: "确定",
  },
  {
    type: 1,
    text: "下一题",
  },
];

let arr_abcd = ["A", "B", "C", "D"];
const mapAnswerToIndex = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
};

const mapTag = {
  1: "单选题",
  2: "多选题",
  3: "判断题",
  4: "满意度调查",
};
export default {
  data() {
    return {
      selectedAnswer: [],
      rightAnswer: [],
      btnStatus: BTN_STATUS[0],
    };
  },
  props: {
    question: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
      require: true,
    },
    maxLength: {
      type: Number,
      require: true,
    },
  },
  created() {
    
    this.rightAnswer = this.question.answer.split("").map((item) => {
      return mapAnswerToIndex[item];
    });
  },
  methods: {
    selectAnswer(answer) {
      if (this.btnStatus.type < 1) {
        if (this.question.type != 2) {
          this.selectedAnswer = [];
          this.selectedAnswer.push(answer);
        } else {
          let isIn = false;
          for (let i = 0; i < this.selectedAnswer.length; i++) {
            if (this.selectedAnswer[i] === answer) {
              this.selectedAnswer.splice(i, 1);
              isIn = true;
              break;
            }
          }
          if (!isIn) {
            this.selectedAnswer.push(answer);
          }
        }
      }

      // console.log('----------');
      // console.log(this.selectedAnswer);
      // console.log(this.rightAnswer);
    },
    onBtnClick() {
      if (this.btnStatus.type == 0) {
        this.calcResult();
        this.btnStatus = BTN_STATUS[1];
      } else if (this.btnStatus.type == 1) {
        if (this.maxLength == this.index + 1) {
          this.$emit("finish", {
            index: this.index,
            result: this.calcResult(),
            level: arr_abcd[this.selectedAnswer[0]],
          });
        } else {
          this.$emit("next", {
            index: this.index,
            result: this.calcResult(),
          });
        }
      }
    },
    calcResult() {
      if (this.question.type == 4) {
        return false;
      } else if (this.selectedAnswer.length !== this.rightAnswer.length) {
        return false;
      } else {
        let l = this.rightAnswer.length,
          reslut = 0;
        this.rightAnswer.map((right) => {
          this.selectedAnswer.map((selected) => {
            if (right == selected) {
              reslut++;
            }
          });
        });
        return l == reslut;
      }
    },
  },
  computed: {
    answers() {
      let arr = [];
      arr_abcd.map((item) => {
        if (this.question[item]) {
          arr.push(this.question[item]);
        }
      });
      return arr;
    },
    questionType() {
      return mapTag[this.question.type];
    },
  },
};
</script>

<style lang="scss" scoped>
.question-item {
  box-shadow: 3px 3px 0 0px rgba(255, 255, 255, 0.7);

  .tag {
    padding: 5px 10px;
    background-color: #f6c914;
    color: #111;
    // font-size: 12px;
    font-weight: lighter;
    box-shadow: 3px 3px 0 0px rgba(246, 201, 20, 0.7);
    margin-bottom: 5px;
  }

  .q-title {
    text-align: left;
    margin-bottom: 10px;
    color: #111;
    font-weight: bold;
  }
  .anwser-item {
    text-align: left;
    min-height: 45px;
    border: 1px solid #111;
    box-shadow: 3px 3px 0 0px #111;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 10px 5px;
    position: relative;
    border-radius: 3px;
    background-position: center right;
    background-repeat: no-repeat;
    background-size: 30px 30px;
    color: #111;
    &.right {
      background-color: #32b16c;
      color: #fff;
      background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936389865090533.png");
    }
    &.error {
      background-color: #ff806f;
      color: #fff;
      background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936396526005144.png");
    }

    &.rest {
      background-color: #f6c914;
      color: #fff;
      background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936389865090533.png");
    }
    &.selected {
      background: #1a4fda;
      color: #fff;
    }
    &::before {
      display: block;
      color: #c76f1f;
      font-weight: bold;
      position: absolute;
      left: -10px;
      top: 0;
      font-size: 35px;
      // text-shadow: 1px 1px 1px #C9DC8B;
    }
    // &:nth-of-type(2)::before {
    //   content: "A";
    // }
    // &:nth-of-type(3)::before {
    //   content: "B";
    // }
    // &:nth-of-type(4)::before {
    //   content: "C";
    // }
    // &:nth-of-type(5)::before {
    //   content: "D";
    // }
  }
}
</style>